import type { SearchParams } from '@/api'

/**
 * Chaves do React Query em um lugar só — evita invalidar cache pelo string
 * errado espalhado pelos componentes.
 */
export const queryKeys = {
  session: ['session'] as const,
  home: ['home'] as const,
  categories: ['categories'] as const,
  search: (params: SearchParams) => ['search', params] as const,
  product: (slug: string) => ['product', slug] as const,
  purchases: ['purchases'] as const,
  adminProducts: (search?: string) => ['admin', 'products', search ?? ''] as const,
}
